<template>
  <div class="quote-wrapper">
    <div class="quote-div">
      <div class="records">
          <div class="title">
            Historial de cotizaciones
          </div>
          <div class="quotes">
            <div class="quote" v-for="quote in quotes" :key="quote.id">
              <div class="quote-element">
                ID:<span class="quote-value">{{ quote.identifier && quote.identifier.slice(-5) }}</span>
              </div>
              <div class="quote-element">
                Cotización:<span class="quote-value">${{ (quote.quote_value).toFixed(2) }}</span>
              </div>
              <div class="quote-element">
                Agendado:
              <span class="quote-value">
                {{ moment(quote.quote_date).format("MMM Do YYYY") }}
              </span>
              </div>
              <div class="quote-element">
                Estatus:
                <span class="quote-value">
                  {{ quote.status === 'progress' ? 'En progreso' : 'Completada '}}
                </span>
              </div>
              <div class="quote-element">
                Comisión:
                <span class="quote-value">
                  ${{ (parseFloat(quote.quote_value) * (parseFloat(3.5)/100)).toFixed(2) }}
                </span>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';

const { mapState, mapActions } = createNamespacedHelpers('quote');
export default {
  data() {
    return {
      moment,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    ...mapState([
      'quotes',
    ]),
  },
  methods: {
    ...mapActions([
      'getAllQuotes',
    ]),
  },
  mounted() {
    this.getAllQuotes();
  },
};
</script>

<style>
.quote-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
}
.quote-div {
  width: 900px;
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 920px) {
  .quote-div {
    width: 95%;
  }
}
.records {
  width: 100%;
  border-radius: 6px;
  padding: 24px;
  box-shadow: 0px 8px 32px 0px rgba(0, 0, 0, 0.25);
  background-color: white;
}
.title {
  font-size: 20px;
}
.quotes {
  display: flex;
  flex-direction: column;
}
.quote {
  border: 1px solid #DCDEDD;
  padding: 14px 16px;
  border-radius: 6px;
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.quote-element {
  width: 48%;
  margin: 4px 0;
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 920px) {
  .quote-element {
    width: 100%;
  }
}
</style>
